import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import styled, { css } from 'styled-components';
import { space, layout, typography } from 'styled-system';
import { getPaletteColor, getTextColor, themeGet } from '@magalu/stereo-ui-styles';
const sizes = {
  auto: css`
    height: auto;
    min-width: auto;
  `,
  small: css`
    height: 32px;
    min-width: 80px;
    font-size: ${props => themeGet('fontSizes.0')(props)}px;
  `,
  medium: css`
    height: 44px;
    min-width: 140px;
    font-size: ${props => themeGet('fontSizes.1')(props)}px;
  `,
  large: css`
    height: 52px;
    min-width: 180px;
    font-size: ${props => themeGet('fontSizes.2')(props)}px;
  `
};
const variations = {
  fill: css`
    ${props => {
    var _props$customColor, _props$customColor2, _props$customColor3, _props$customColor4;

    return `
      background-color: 
        ${(_props$customColor = props.customColor) != null && _props$customColor.default ? (_props$customColor2 = props.customColor) == null ? void 0 : _props$customColor2.default : getPaletteColor('base')(props)};
      color: ${getTextColor('lightest')(props)};
      svg {
        fill: ${getTextColor('lightest')(props)};
      }

      &:hover {
        background-color: 
        ${(_props$customColor3 = props.customColor) != null && _props$customColor3.hover ? (_props$customColor4 = props.customColor) == null ? void 0 : _props$customColor4.hover : getPaletteColor('dark')(props)};
        color: ${getTextColor('lightest')(props)};
      }
    `;
  }};

    ${props => props.disabled && `
      &,
      &:hover {
        background-color: ${getPaletteColor('background.whisper')(props)};
        color: ${getTextColor('scratched')(props)};
        svg {
          fill: ${getTextColor('scratched')(props)};
        }
      }
    `};

    ${props => {
    var _props$customColor5, _props$customColor6, _props$customColor7, _props$customColor8, _props$customColor9, _props$customColor10, _props$customColor11, _props$customColor12, _props$customColor13, _props$customColor14;

    return !props.disabled && props.invertedColors && `
      background-color: 
        ${(_props$customColor5 = props.customColor) != null && _props$customColor5.default ? (_props$customColor6 = props.customColor) == null ? void 0 : _props$customColor6.default : getPaletteColor('base')(props)};
      color:
        ${(_props$customColor7 = props.customColor) != null && _props$customColor7.hover ? (_props$customColor8 = props.customColor) == null ? void 0 : _props$customColor8.hover : getTextColor('lightest')(props)};
      svg {
        fill: ${getTextColor('lightest')(props)};
      }

      &:hover {
        background-color:
          ${(_props$customColor9 = props.customColor) != null && _props$customColor9.hover ? (_props$customColor10 = props.customColor) == null ? void 0 : _props$customColor10.hover : getTextColor('lightest')(props)};
        color: ${(_props$customColor11 = props.customColor) != null && _props$customColor11.default ? (_props$customColor12 = props.customColor) == null ? void 0 : _props$customColor12.default : getPaletteColor('base')(props)};
        svg {
          fill: ${(_props$customColor13 = props.customColor) != null && _props$customColor13.hover ? (_props$customColor14 = props.customColor) == null ? void 0 : _props$customColor14.hover : getPaletteColor('base')(props)};
        }
      }
    `;
  }};
  `,
  outline: css`
    ${props => {
    var _props$customColor15, _props$customColor16, _props$customColor17, _props$customColor18, _props$customColor19, _props$customColor20, _props$customColor21, _props$customColor22, _props$customColor23, _props$customColor24, _props$customColor25, _props$customColor26;

    return `
    background-color: transparent;
    box-shadow: inset 0 0 0 1px
      ${(_props$customColor15 = props.customColor) != null && _props$customColor15.default ? (_props$customColor16 = props.customColor) == null ? void 0 : _props$customColor16.default : getPaletteColor('base')(props)};
    color: ${(_props$customColor17 = props.customColor) != null && _props$customColor17.default ? (_props$customColor18 = props.customColor) == null ? void 0 : _props$customColor18.default : getPaletteColor('base')(props)};
    svg {
      fill: ${(_props$customColor19 = props.customColor) != null && _props$customColor19.default ? (_props$customColor20 = props.customColor) == null ? void 0 : _props$customColor20.default : getPaletteColor('base')(props)};
    }

    &:hover {
      box-shadow: inset 0 0 0 1px
        ${(_props$customColor21 = props.customColor) != null && _props$customColor21.hover ? (_props$customColor22 = props.customColor) == null ? void 0 : _props$customColor22.hover : getPaletteColor('dark')(props)};
      color: ${(_props$customColor23 = props.customColor) != null && _props$customColor23.hover ? (_props$customColor24 = props.customColor) == null ? void 0 : _props$customColor24.hover : getPaletteColor('dark')(props)};
      svg {
        fill: ${(_props$customColor25 = props.customColor) != null && _props$customColor25.hover ? (_props$customColor26 = props.customColor) == null ? void 0 : _props$customColor26.hover : getPaletteColor('dark')(props)};
      }
    }
  `;
  }}

    ${props => props.disabled && `
      &,
      &:hover {
        background-color: transparent;
        box-shadow: inset 0 0 0 1px ${getTextColor('lighter')(props)};
        color: ${getTextColor('lighter')(props)};
        svg {
          fill: ${getTextColor('lighter')(props)};
        }
      }
    `}
  `
};
export const StartIcon = styled.span`
  grid-area: start;
  svg {
    vertical-align: middle;
    float: left;
  }
`;
export const Content = styled.label`
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  font-weight: ${props => themeGet('fontWeights.medium')(props)};
  text-align: center;
  margin-top: 1px;
  grid-area: label;
  align-self: center;
  small {
    font-weight: ${props => themeGet('fontWeights.medium')(props)};
    text-transform: none;
    display: block;
  }
`;
export const EndIcon = styled.span`
  grid-area: end;
  svg {
    vertical-align: middle;
    float: right;
  }
`;
export const ButtonBase = styled.button`
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  font-family: ${props => themeGet('fontFamily')(props)};
  outline: none;
  border: none;
  border-radius: ${props => props.rounded ? '30px' : '4px'};
  padding: 0px 15px;
  width: ${props => props.full ? '100%' : 'auto'};
  display: grid;
  grid-column: ${props => props.gridColumn || 'unset'};
  grid-template-areas: ${props => !props.startIcon && !props.endIcon ? "'label'" : "'start label end'"};
  ${_ref => {
  let {
    centered
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["centered"]);

  return centered ? css`
          grid-template-columns: '';
          grid-gap: 0px
            ${props.startIcon || props.endIcon ? themeGet('space.2')(props) : 0}px;
        ` : css`
          grid-template-columns: ${!props.startIcon && !props.endIcon ? 'auto' : '1fr 4fr 1fr'};
        `;
}}
  justify-content: center;
  align-content: center;
  text-decoration: none;
  ${Content} {
    ${({
  uppercase
}) => uppercase && css`
        text-transform: uppercase;
      `}
  }
  ${props => sizes[props.size] || sizes.medium}
  ${props => variations[props.variation] || variations.fill}
  ${space}
  ${layout}
  ${typography}
`;